<template>
  <block-template
    :data="data"
    title="Текстовый блок"
    :possible-next="possibleNext"
    :is-last="isLast"
  >
    <div v-html="data.content" />
  </block-template>
</template>

<script>
import BlockTemplate from "./Template";
export default {
  name: "BlockText",
  components: { BlockTemplate },
  props: {
    data: {
      type: Object,
      required: true,
      content: {
        type: String,
        default: ""
      },
      parent_type: {
        type: String,
        required: true
      },
      parent_id: {
        type: Number,
        required: true
      }
    },
    possibleNext: {
      type: Object,
      required: true
    },
    isLast: {
      type: Boolean,
      default: false
    }
  }
};
</script>
